// The "Vorschläge aus Mails" wire calls (the Gmail add-on;
// server: `apps/server/src/http/gmail-proposals.ts`). The list is parsed with
// the shared DTO (`@loom/shared/gmail`), so a field the server adds without
// declaring it there never reaches the page.
//
// Accept and Decline answer a closed code on failure (`{error: "<code>"}`);
// `failureCodeOf` (`../../lib/http`) reads it and the list shows catalog copy
// for it, never the body. On success the list reads again, so the answer's
// own body is not used.

import { MailProposalListDto } from "@loom/shared/gmail";

import { httpGet, httpPostNoContent } from "../../lib/http";

export const MAIL_PROPOSALS_PATH = "/api/gmail/proposals";

export type MailProposalAction = "accept" | "decline";

/** The caller's own filed mail proposals for one project, newest first. */
export const listMailProposals = (projectId: number): Promise<MailProposalListDto> =>
  httpGet(
    `${MAIL_PROPOSALS_PATH}?${new URLSearchParams({ projectId: String(projectId) }).toString()}`,
    MailProposalListDto,
    { cache: "no-store" },
  );

/** Accept or Decline one proposal, named by its topic id. */
export const mailProposalAction = (topicId: string, action: MailProposalAction): Promise<void> =>
  httpPostNoContent(`${MAIL_PROPOSALS_PATH}/${encodeURIComponent(topicId)}/${action}`, {});
